var ASYMMETRIC_KEY_DETAILS_SUPPORTED = require('./asymmetricKeyDetailsSupported');

var RSA_PSS_KEY_DETAILS_SUPPORTED = require('./rsaPssKeyDetailsSupported');

var allowedAlgorithmsForKeys = {
  'ec': ['ES256', 'ES384', 'ES512'],
  'rsa': ['RS256', 'PS256', 'RS384', 'PS384', 'RS512', 'PS512'],
  'rsa-pss': ['PS256', 'PS384', 'PS512']
};
var allowedCurves = {
  ES256: 'prime256v1',
  ES384: 'secp384r1',
  ES512: 'secp521r1'
};

module.exports = function (algorithm, key) {
  if (!algorithm || !key) return;
  var keyType = key.asymmetricKeyType;
  if (!keyType) return;
  var allowedAlgorithms = allowedAlgorithmsForKeys[keyType];

  if (!allowedAlgorithms) {
    throw new Error("Unknown key type \"".concat(keyType, "\"."));
  }

  if (!allowedAlgorithms.includes(algorithm)) {
    throw new Error("\"alg\" parameter for \"".concat(keyType, "\" key type must be one of: ").concat(allowedAlgorithms.join(', '), "."));
  }
  /*
   * Ignore the next block from test coverage because it gets executed
   * conditionally depending on the Node version. Not ignoring it would
   * prevent us from reaching the target % of coverage for versions of
   * Node under 15.7.0.
   */

  /* istanbul ignore next */


  if (ASYMMETRIC_KEY_DETAILS_SUPPORTED) {
    switch (keyType) {
      case 'ec':
        var keyCurve = key.asymmetricKeyDetails.namedCurve;
        var allowedCurve = allowedCurves[algorithm];

        if (keyCurve !== allowedCurve) {
          throw new Error("\"alg\" parameter \"".concat(algorithm, "\" requires curve \"").concat(allowedCurve, "\"."));
        }

        break;

      case 'rsa-pss':
        if (RSA_PSS_KEY_DETAILS_SUPPORTED) {
          var length = parseInt(algorithm.slice(-3), 10);
          var _key$asymmetricKeyDet = key.asymmetricKeyDetails,
              hashAlgorithm = _key$asymmetricKeyDet.hashAlgorithm,
              mgf1HashAlgorithm = _key$asymmetricKeyDet.mgf1HashAlgorithm,
              saltLength = _key$asymmetricKeyDet.saltLength;

          if (hashAlgorithm !== "sha".concat(length) || mgf1HashAlgorithm !== hashAlgorithm) {
            throw new Error("Invalid key for this operation, its RSA-PSS parameters do not meet the requirements of \"alg\" ".concat(algorithm, "."));
          }

          if (saltLength !== undefined && saltLength > length >> 3) {
            throw new Error("Invalid key for this operation, its RSA-PSS parameter saltLength does not meet the requirements of \"alg\" ".concat(algorithm, "."));
          }
        }

        break;
    }
  }
};